import { eventEmitter } from "./index";

export default function registerPaymentEvents() {
  eventEmitter.on("payment:proceed_to_checkout_page", () => {
    window.analytics.track("proceed_to_checkout_page");
  });
}
